"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Checkbox_module_css_1 = __importDefault(require("./Checkbox.module.css"));
exports.Checkbox = react_1.default.forwardRef(({ size = 'xs', variant = 'contained', color = 'primary', className, ...props }, ref) => {
    return (react_1.default.createElement("span", { className: classnames_1.default(className, Checkbox_module_css_1.default.checkbox, Checkbox_module_css_1.default[size], Checkbox_module_css_1.default[`variant-${variant}`], Checkbox_module_css_1.default[`color-${color}`], {
            [Checkbox_module_css_1.default.disabled]: props.disabled,
            [Checkbox_module_css_1.default.readOnly]: props.readOnly
        }) },
        react_1.default.createElement("input", Object.assign({}, props, { ref: ref, disabled: props.disabled || props.readOnly, className: classnames_1.default(Checkbox_module_css_1.default.input), type: "checkbox" })),
        react_1.default.createElement("span", { className: Checkbox_module_css_1.default.tick })));
});
//# sourceMappingURL=Checkbox.js.map